import { environment } from "../../environments/environment";

function clarityProjectId(): string {
  const w = window as unknown as { __CLARITY_PROJECT_ID__?: string };
  return w.__CLARITY_PROJECT_ID__?.trim() || environment.clarityProjectId.trim();
}

/**
 * Deep link to Clarity session recordings filtered by our visitor id (the id
 * the customer app passes to clarity("identify"), stored on the draft).
 *
 * ponytail: `CustomUserId=is;<id>` mirrors the link format OpnForm uses against
 * Clarity's recordings. If Clarity changes the query param, adjust here only.
 */
export function clarityRecordingUrl(customUserId?: string): string {
  const project = clarityProjectId();
  if (!project || !customUserId) return "";
  return `https://clarity.microsoft.com/projects/view/${project}/recordings?CustomUserId=is%3B${encodeURIComponent(customUserId)}`;
}
